import CONST from '@/constants/rh/employe';
export default {
  methods: {
    getStatutEO(value) {
      let statut = '';
      switch (value) {
        case CONST.OBJ_ATTENTE:
          statut = CONST.TXT_OBJ_ATTENTE;
          break;
        case CONST.OBJ_ATTEINT:
          statut = CONST.TXT_OBJ_ATTEINT;
          break;
        case CONST.OBJ_NON_ATTEINT:
          statut = CONST.TXT_OBJ_NON_ATTEINT;
          break;
      }
      return statut;
    },
    getClassOfEO(value) {
      let cls = 'text-warning';
      switch (value) {
        case CONST.OBJ_ATTENTE:
          cls = 'text-warning';
          break;
        case CONST.OBJ_ATTEINT:
          cls = 'text-success';
          break;
        case CONST.OBJ_NON_ATTEINT:
          cls = 'text-danger';
          break;
      }
      return cls;
    },
  },
};
